<h2 mat-dialog-title>Privacy Notice</h2>

<mat-dialog-content class="scrollable-text" [innerHTML]="privacyContent">
</mat-dialog-content>

<mat-dialog-actions >
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
